import { Injectable, OnDestroy } from '@angular/core';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable, of } from 'rxjs';
import { SubSink } from 'subsink';
import { DataDogService } from './data-dog.service';

@Injectable({
  providedIn: 'root',
})
export class AppMonitoringService implements OnDestroy {
  private enableLogging: boolean;
  private enableRum: boolean;
  private subSink = new SubSink();

  constructor(
    private appConfigSetting: AppConfigSettings,
    private dataDogService: DataDogService
  ) {}

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  init(): Observable<void> {
    this.enableLogging =
      this.appConfigSetting.getconfig('enableBrowserLogging') === 'true';
    this.enableRum =
      this.appConfigSetting.getconfig('enableBrowserRum') === 'true';

    this.initializeUserStore();
    return of();
  }

  private initializeUserStore(): void {
    if (!this.enableRum) {
      return;
    }

    this.dataDogService.initializeRum();
  }

  logError(error: unknown, context?: Record<string, unknown>): void {
    if (!this.enableLogging) {
      return;
    }

    this.dataDogService.logError(error, context);
  }
}
